const LIST_PATH = "/cases";

export const casePaths = {
  list: LIST_PATH,
  detail: id => `${LIST_PATH}/${id}`,
  edit: id => `${LIST_PATH}/${id}/edit`,
};
